import React, { useState } from "react";
import { compose } from "redux";

import { reportsConnector } from "../../../services/reports/connector";

import TaxReportsInternal from "./TaxReportsInternal";
import TaxReportsTransferTax from "./TaxReportsTransferTax";
import TaxReportsDisplay from "./TaxReportsDisplay";
import CardActions from "@material-ui/core/CardActions";
import Card from "@material-ui/core/Card";
import { savelendConnector } from "../../../services/savelendWithdrawals/connector";
import TaxAccountBalance from "./Tax.Account.Balance";
import { Currencies } from "../../../shared/dictionary/enums";

const TaxReportsComponent = ({ reports, getSekTaxReport, getEurTaxReport }) => {
  const [Year, changeYear] = useState("");
  const [Month, changeMonth] = useState("");

  return (
    <React.Fragment>
      <Card className="card-style3">
        <div className="row">
          <div className="col-md-12">
            <TaxAccountBalance />
          </div>
        </div>
      </Card>

      <div className="row">
        <div className="col-md-12">
          <h3>Tax Reports:</h3>
        </div>
      </div>
      <TaxReportsInternal
        year={Year}
        changeYear={(event) => {
          changeYear(event.target.value);
        }}
        month={Month}
        changeMonth={(event) => {
          changeMonth(event.target.value);
        }}
        fetching={reports.fetching}
        fetched={reports.fetched}
        error={reports.error}
        getReport={getReports}
      />

      <CardActions>
        <span>
          <div className={"col-md-9"}>
            {reports.taxReports.SEK && (
              <TaxReportsDisplay
                report={reports.taxReports.SEK}
                currency={Currencies.Sek}
              />
            )}
            <br />
            <TaxReportsTransferTax currency={Currencies.Sek} />
          </div>

          <div className={"col-md-3"}>
            {reports.taxReports.EUR && (
              <TaxReportsDisplay
                report={reports.taxReports.EUR}
                currency={Currencies.Eur}
              />
            )}
            <br />
            <TaxReportsTransferTax currency={Currencies.Eur} />
          </div>
        </span>
      </CardActions>
      <br />
      <div style={{ color: "red" }}>{reports.taxTransfer.error}</div>
      <hr />
    </React.Fragment>
  );

  function getReports() {
    getSekTaxReport(Month, Year);
    getEurTaxReport(Month, Year);
  }
};

export default compose(
  savelendConnector,
  reportsConnector,
)(TaxReportsComponent);
